import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar/Navbar';
import UsersTab from '../components/UsersTab';
import { useTranslation } from '../hooks/useTranslation';
import './ConsumersPage.css';

const ConsumersPage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="consumers-page">
      <Navbar />
      <div className="consumers-page-content">
        <div className="consumers-page-header">
          <button className="back-btn" onClick={() => navigate(-1)}>
            ← {t('common.back')}
          </button>
        </div>
        <UsersTab onBack={() => {}} />
      </div>
    </div>
  );
};

export default ConsumersPage;

